export default __webpack_public_path__ + "static/media/a8.b8af0094.png";